import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Box, Button, InputLabel, Modal, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGoodsInSingleData,
  approveGoodsinAction,
  Addremarks,
  deleteGoodsinRecord,
} from "src/thunks/goodsin";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { GoodsForm } from "./components/addGoods";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconError from "src/assets/images/icon_error.svg";
import { toast } from "react-toastify";
import IconRemove from "src/assets/images/icon_remove.svg";
import { Loader } from "src/components/loader";
import toastMessages from "src/constant/toastMessages.json";
import { GetError, convertIsoToLocalDateTime, getFloatValue, tConvert } from "src/constant";
import { CheckBox } from "@mui/icons-material";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";
import DeleteIcon from "@mui/icons-material/Delete";
import IconCancel from "src/assets/images/icon_cancel.svg";
import UploadImage from "src/components/GoodsinImageModal";
import CollectionsIcon from "@mui/icons-material/Collections";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "46%",
  transform: "translate(-50%, -50%)",
  width: "77%",
  height: "100%",
  bgcolor: "background.paper",
  overflowY: "scroll",
};

const modalStyle1 = {
  position: "absolute",
  top: "50%",
  left: "46%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  height: "70%",
  bgcolor: "background.paper",
  overflowY: "scroll",
};

export const Details = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const lookupValues = useSelector((state) => state.lookup.data);
  const state = useSelector((state) => state.goodsin);


  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = useState(false);
  const [filesArray, setFilesArray] = useState([]);
  const [document, setdocument] = useState([]);
  const [showRemark, setShowRemark] = useState(false);
  const [openApprovedModel, _openApprovedModel] = useState(false);
  const [revokeApprovalModal, _revokeApprovalModal] = useState(false);
  const [deleteRecordModal, _deleteRecordModal] = useState(false);
  const [backDatedObj, setBackDatedObj] = useState({
    isBackdatedEntry: false,
    backDatedDate: "",
  });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAllImages, setShowAllImages] = useState(false);
  const [selectedItemImagesArray, setSelectedItemImagesArray] = useState([]);
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  };
  const [loader,setLoader] = useState(false)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      comments: "",
    },
    resolver: yupResolver(
      yup.object().shape({
        comments: yup.string().required("Remarks is rquired"),
      })
    ),
  });

  /** variable declarations ----------------------------------------------------- **/
  let { id } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const goodsData = { ...state.goodsData };
  let damageCount =
    _.filter(goodsData?.items, (d) => d.conditionValue === "Damaged")?.length ||
    0;
  let unitsCount = _.sumBy(goodsData?.items, (d) => d.quantityReceived) || 0;
  let iternalspaceCount = _.sumBy(
    _.filter(goodsData?.items, (d) => d.storageValue === "interior") || [],
    (d1) => d1.spaceOccupied
  );
  let EXTERIORspaceCount = _.sumBy(
    _.filter(goodsData?.items, (d) => d.storageValue === "exterior") || [],
    (d1) => d1.spaceOccupied
  );
  const projectManager = goodsData?.projectManager || {};
  const depotManager = goodsData?.depotManager || {};
  const remarks = _.orderBy(goodsData.shipmentRemarks, ["timeStamp"], ["desc"]);
  if (goodsData?.items) {
    let mappedItems = goodsData?.items.map((i) => {
      return {
        ...i,
        condition: lookupValues.find((l) => l.id == i.conditionId)?.name,
        storage: lookupValues.find((l) => l.id == i.storageId)?.name,
      };
    });
    goodsData.items = [...mappedItems];
  }
  goodsData.type = lookupValues?.find((v) => v.id == goodsData?.typeId)?.name;
  const originalDateTime = new Date(goodsData?.statusChangedEventDate);
  const convertedDateTimeForRevokeAPproval = new Date(
    originalDateTime.getTime() + 48 * 60 * 60 * 1000
  );

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getGoodsInDataFunc();
  }, [id]);

  useEffect(() => {
    if (goodsData) {
      let PhotoType = lookupValues.find((v) => v.name === "Pictures")?.id;
      let DocumentType = lookupValues.find((v) => v.name === "Documents")?.id;
      let imageArray = _.filter(
        goodsData?.shipmentEvidences,
        (d) => d.typeId === PhotoType
      );
      setFilesArray([...imageArray]);
      let documentArray = _.filter(
        goodsData?.shipmentEvidences,
        (d) => d.typeId === DocumentType
      );
      setdocument([...documentArray]);
    }
  }, [state]);

  /** handler functions--------------------------------------------------- **/
  const handleClose = () => setOpen(false);

  const getGoodsInDataFunc = async () => {
    setLoader(true)
    try {
      let data = await dispatch(getGoodsInSingleData({ id: id })).unwrap();
      setLoader(false)
      if (!data) {
        toast.error("Record Not found.");
        navigate("/app/goodsin/list");
      }
    } catch (err) {
      setLoader(false)
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const handleSubmitRemark = async (data) => {
    let newData = {
      id: goodsData?.id,
      shipmentRemarks: data?.comments,
      apiModule: "Shipment",
      userDetails:
        userDetails?.firstName || "" + " " + userDetails?.lastName || "",
      referenceNumber: goodsData?.referenceNumber,
      projectId: goodsData?.projectId,
    };
    try {
      let result = await dispatch(Addremarks({ ...newData })).unwrap();
      getGoodsInDataFunc();
      if (result) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.remarkAdded);
        setShowRemark(false);
        reset();
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleCancelRemark = () => {
    setShowRemark(!showRemark);
    reset();
  };

  const openFullScreen = (image) => {
    setIsFullScreen(true);
    setSelectedImage(image);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
    setSelectedImage(null);
  };

  const handleApproveScreenGoBackClick = async() =>{
    _openApprovedModel(!openApprovedModel);
    await getGoodsInDataFunc();

  }

  const handleApproveRecordButtonClick = async () => {
    try {
      let result = await dispatch(
        approveGoodsinAction({
          id: id,
          approveAction: 0,
          referenceNumber: goodsData?.referenceNumber || "",
          depotId: goodsData?.depotId || "",
          depotCode: goodsData?.depotCode || "",
          ClientName: goodsData?.clientName || "",
          projectId: goodsData?.projectId || "",
        })
      ).unwrap();
      if (result) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.goodsinApproved);
        _openApprovedModel(!openApprovedModel);
        getGoodsInDataFunc();
      }
    } catch (error) {
      toast.error(
        GetError(error?.response?.data?.errors) ||
        error?.message ||
        "something issue"
      );
    }
  };

  const handleRevokeApprovalButtonClick = async () => {
    try {
      let result = await dispatch(
        approveGoodsinAction({
          id: id,
          approveAction: 1,
          referenceNumber: goodsData?.referenceNumber || "",
          depotId: goodsData?.depotId || "",
          depotCode: goodsData?.depotCode || "",
          ClientName: goodsData?.clientName || "",
          projectId: goodsData?.projectId || "",
        })
      ).unwrap();
      if (result) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.goodsinRevoked);
        _revokeApprovalModal(!revokeApprovalModal);
        getGoodsInDataFunc();
      }
    } catch (error) {
      toast.error(
        GetError(error?.response?.data?.errors) ||
        error?.message ||
        "something issue"
      );
    }
  };

  const handleDeleteRecordClick = async () => {
    try {
      await dispatch(
        deleteGoodsinRecord({
          id: id,
          referenceNumber: goodsData?.referenceNumber || "",
          depotId: goodsData?.depotId || "",
          depotCode: goodsData?.depotCode || "",
          ClientName: goodsData?.clientName || "",
          projectId: goodsData?.projectId || "",
        })
      ).unwrap();
      setTimeout(() => {
        dispatch(getAllNofificationForDashboard(1, 20));
      }, 2000);
      toast.success(toastMessages.goodsinDeleted);
      _deleteRecordModal(!deleteRecordModal);
      navigate("/app/goodsin/list");
    } catch (error) {
      toast.error(
        GetError(error?.response?.data?.errors) ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const handleViewAllImagesClick = (item) => {
    setShowAllImages(!showAllImages);
    setSelectedItemImagesArray([...item.shipmentItemEvidences]);
  };

  const handleClosemodal = () => {
    setShowAllImages(false);
  };

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <div
        className={`main-details-div-for-goodsin ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
          }`}
      >
        <div className="row">
          <div
            className="d-flex justify-content-center first-row-details-goodsin-page"
            onClick={() => navigate(-1)}
          >
            <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
              <img src={IconLeftArrow} alt="left arrow" />
            </div>
          </div>
          <div className="goodsin-subdiv-style">
            <div className="ms-2 me-2">
              <div className="row d-flex align-items-center first-row-in-goodsin-details">
                <div className="col-md-5 details-ref-number-style">
                  {goodsData?.referenceNumber || ""}
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  <span className="d-flex align-items-center goodsin-received-date-text-style">
                    RECEIVED{" "}
                  </span>
                  <span className="details-top-date-text-style ps-2">
                    {moment(goodsData?.date).format("DD-MMM-YYYY")}{" "}
                    {tConvert(goodsData?.time)}
                    {/* {convertIsoToLocalDateTime(`${goodsData?.date}.00Z`, "DD-MMM-YYYY HH:mm")} */}
                  </span>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <span className="d-flex align-items-center goodsin-received-date-text-style">
                    STATUS
                  </span>
                  <span
                    className={`text-uppercase goodsin-details-status-color ps-2 ${goodsData?.statusValue == "Review"
                      ? "review-status-color"
                      : "approved-status-color"
                      }`}
                  >
                    {goodsData?.statusValue}
                  </span>
                </div>
              </div>

              <div className="d-flex flex-column pt-4 pb-4 add-border-inbetween-class">
                <div className="d-flex flex-row">
                  <div className="col-md-6 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      {" "}
                      CLIENT{" "}
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {" "}
                      {goodsData?.clientName || ""}
                    </div>
                    <div className="details-goodsin-address-text-style word-wrap-or-text-wrap text-start">
                      {goodsData?.clientAddress?.street1 ||
                        goodsData?.clientAddress?.street2}
                      ,{goodsData?.clientAddress?.city},
                      {goodsData?.clientAddress?.state}
                      {goodsData?.clientAddress?.country},
                      {goodsData?.clientAddress?.zip}{" "}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="goodsin-received-date-text-style">
                      PROJECT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {projectManager?.firstName} {projectManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {projectManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style word-wrap-or-text-wrap text-start">
                      {projectManager?.phoneNumber}
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-row mt-3">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      PROJECT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {goodsData?.projectName}
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      VEHICLE
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {goodsData?.vrn || ""}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="goodsin-received-date-text-style">
                      DRIVER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {goodsData?.driverName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {goodsData?.driverContact || ""}
                    </div>
                  </div>
                </div>

                <div className="d-flex flx-row mt-3">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      APPROVED BY
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {goodsData?.approvedBy?.firstName || ""}{" "}
                      {goodsData?.approvedBy?.lastName || ""}
                    </div>
                    <div className="details-goodsin-address-text-style word-wrap-or-text-wrap">
                      {goodsData?.approvedBy?.email || ""}
                    </div>
                    <div className="details-goodsin-address-text-style word-wrap-or-text-wrap">
                      {goodsData?.approvedBy?.phoneNumber || ""}
                    </div>
                    <div className="details-goodsin-address-text-style text-uppercase add-approved-date-color word-wrap-or-text-wrap">
                      {/* {goodsData?.approvedBy?.approvedOn &&
                        moment(goodsData?.approvedBy?.approvedOn).format(
                          "DD-MM-YYYY hh:mm"
                        )} */}
                      {goodsData?.approvedBy?.approvedOn &&
                        convertIsoToLocalDateTime(`${goodsData?.approvedBy?.approvedOn}.00Z`, "DD-MMM-YYYY HH:mm")
                      }
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      DEPOT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {goodsData?.depotName || ""}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="goodsin-received-date-text-style">
                      DEPOT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {depotManager?.firstName} {depotManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.phoneNumber}
                    </div>
                  </div>
                </div>
                <div className="d-flex flx-row mt-3">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      INTERNAL
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap" style={{
                      fontWeight: 800
                    }}>
                      {goodsData?.internalSpaceOccupied || 0
                      } < span style={{ marginLeft: 2 }}>M<sup>2</sup></span>
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      EXTERNAL
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap" style={{
                      fontWeight: 800
                    }}>
                      {goodsData?.externalSpaceOccupied || 0
                      } < span style={{ marginLeft: 2 }}>M<sup>2</sup></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row add-border-inbetween-class pt-3 pb-2">
                <table
                  className="table goodsin-table table-borderless p-0"
                  style={{ width: "100%" }}
                >
                  <thead className="goodsin-table-header">
                    <tr style={{ width: "100%" }}>
                      <th
                        scope="col"
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "25%" }}
                      >
                        <span className="items-table-header-count">
                          {goodsData?.items?.length || 0}
                        </span>
                        <span className="items-table-text"> ITEMS</span>
                      </th>
                      <th
                        scope="col"
                        className={` text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "25%" }}
                      >
                        <span className="items-table-header-count">
                          {damageCount}
                        </span>
                        <span className="items-table-text"> DAMAGED</span>
                      </th>
                      <th
                        scope="col"
                        className={`text-uppercase text-primary set-header-width-for-medium-text`}
                        style={{ width: "25%" }}
                      >
                        <span className="items-table-text">DESCRIPTION</span>
                      </th>
                      <th
                        scope="col"
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "8%" }}
                      >
                        <span className="items-table-header-count">
                          {unitsCount}
                        </span>
                        <span className="items-table-text"> UNITS</span>
                      </th>
                      {/* <th
                        scope="col"
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "8%" }}
                      >
                        <span className="items-table-header-count">
                          {getFloatValue(iternalspaceCount)} M<sup>2</sup>
                        </span>
                        <span className="items-table-text"> INTERNAL</span>
                      </th>
                      <th
                        scope="col"
                        className={` text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "8%" }}
                      >
                        <span className="items-table-header-count">
                          {getFloatValue(EXTERIORspaceCount)} M<sup>2</sup>
                        </span>
                        <span className="items-table-text"> EXTERNAL</span>
                      </th> */}
                      <th
                        scope="col"
                        className={` text-uppercase text-primary`}
                        style={{ width: "8%", minWidth: 20 }}
                      >
                        <span className="items-table-text"> IMAGES</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="goods-table-body">
                    {goodsData?.items?.length > 0 &&
                      _.orderBy(
                        goodsData?.items || [],
                        ["itemNumber"],
                        ["asc"]
                      ).map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className="goodsin-items-tr"
                            style={{ width: "100%" }}
                          >
                            <td style={{ width: "25%" }}>{item.itemNumber}</td>
                            <td style={{ width: "25%" }}>{item.condition}</td>
                            <td style={{ width: "25%" }}>{item.description}</td>
                            <td style={{ width: "8%" }}>
                              {item.quantityReceived}
                            </td>
                            {/* <td style={{ width: "8%" }}>
                              {item.storageValue === "interior"
                                ? item.spaceOccupied
                                : "0"}
                            </td>
                            <td style={{ width: "8%" }}>
                              {item.storageValue === "exterior"
                                ? item.spaceOccupied
                                : "0"}
                            </td> */}
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() => handleViewAllImagesClick(item)}
                            >
                              {/* <CollectionsIcon /> */}
                              <Button
                                variant="outlined"
                                className="btn-bootstrap-submit-style"
                              >
                                <CollectionsIcon />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              {filesArray?.length > 0 && (
                <>
                  <div className="row pt-4">
                    <span className="photos-text-style-details-goodsin">
                      {filesArray?.length || ""} PHOTOS
                    </span>
                    {filesArray.map((d, index) => {
                      return (
                        <div
                          key={index}
                          className="mb-2 pt-2 images-shown-style image-grid"
                        >
                          <Box
                            className="image-box-style"
                            component="img"
                            alt="The house from the offer."
                            src={d.url}
                            style={{ cursor: "pointer" }}
                            onClick={() => openFullScreen(d.url)}
                          ></Box>
                          {d.isDamaged ? (
                            <div className="dmg-icon-shown-on-image-style">
                              <img
                                height={25}
                                width={25}
                                src={IconError}
                                alt="dmg"
                              />
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              {isFullScreen && (
                <div className="full-screen-overlay" onClick={closeFullScreen}>
                  <div className="full-screen-image">
                    <img src={selectedImage} alt="Full-screen Image" />
                  </div>
                </div>
              )}

              {document?.length > 0 && (
                <div className="row pt-3 pb-4 add-border-inbetween-class">
                  <span className="photos-text-style-details-goodsin">
                    {document?.length || 0} DOCUMENT
                  </span>
                  {document.map((d, index) => {
                    return (
                      <div key={index} className="row mt-2">
                        <a href={d.url} target="_blank">
                          <div className="col-md-12">
                            {d?.fileName || "dsd"}
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              )}
              <div
                className="d-flex justify-content-between mt-4"
                style={{ marginBottom: "1px solid gray" }}
              >
                <Button
                  disabled={goodsData?.statusValue == "Approved" ? true : false}
                  className={`${goodsData?.statusValue == "Approved"
                    ? "add-cancel-order-bg-color"
                    : ""
                    }`}
                  variant="outlined"
                  onClick={() => setOpen(!open)}
                >
                  <img
                    className="me-1"
                    width={15}
                    height={20}
                    src={require("../../assets/images/edit.png")}
                  />
                  EDIT RECORD
                </Button>

                {(userDetails?.roles == "SuperAdmin" ||
                  userDetails?.roles == "Admin" ||
                  (userDetails?.roles == "DepotManager" &&
                    goodsData?.statusValue == "Review")) && (
                    <div
                    // style={{ marginRight: 116 }}
                    >
                      <Button
                        className="cancel-order-dispatchedit-btn-style"
                        variant="outlined"
                        onClick={() => _deleteRecordModal(!deleteRecordModal)}
                      >
                        <DeleteIcon
                          className="remove-item-icon-color"
                          style={{
                            cursor: "pointer",
                            color: "red",
                            fontSize: 20,
                          }}
                        />
                        DELETE RECORD
                      </Button>
                    </div>
                  )}

                {goodsData?.statusValue == "Review" &&
                  (userDetails?.roles == "SuperAdmin" ||
                    userDetails?.roles == "Admin") && (
                    <Button
                      style={{ color: "green", borderColor: "green" }}
                      className="details-goodsin-approve-btn-style"
                      variant="outlined"
                      onClick={() => _openApprovedModel(!openApprovedModel)}
                    >
                      <img
                        className="me-1"
                        width={15}
                        height={20}
                        src={require("../../assets/images/approved.png")}
                      />
                      APPROVE RECORD
                    </Button>
                  )}

                {goodsData?.statusValue == "Approved" &&
                  (userDetails?.roles == "SuperAdmin" ||
                    userDetails?.roles == "Admin") && (
                    <Button
                      // className={`unlist-depot-button-style ${new Date() < convertedDateTimeForRevokeAPproval ? "" : "add-cancel-order-bg-color"}`}
                      className={`unlist-depot-button-style`}
                      variant="outlined"
                      onClick={() => _revokeApprovalModal(!revokeApprovalModal)}
                    // disabled={
                    //   new Date() < convertedDateTimeForRevokeAPproval
                    //     ? false
                    //     : true
                    // }
                    >
                      <img
                        className="me-1"
                        width={15}
                        height={20}
                        src={IconRemove}
                      />
                      REVOKE APPROVAL
                    </Button>
                  )}
              </div>

              <div className="d-flex justify-content-end mt-3"></div>

              <div style={{ height: 100 }}></div>
            </div>
          </div>

          <div className="goodsin-details-remark-section-main-div-style ps-0">
            {showRemark ? (
              <div className="pb-3 add-border-between-remarks-goodsin">
                <div className="pt-2 ms-2 remark-add-div-goodsin-details">
                  <form onSubmit={handleSubmit(handleSubmitRemark)}>
                    <TextField
                      id="outlined-basic"
                      label="Something is being typed here"
                      variant="outlined"
                      multiline
                      {...register("comments")}
                    />
                    {errors.comments ? (
                      <div className=" mt-1 text-danger error-remark-style">
                        {errors.comments?.message}
                      </div>
                    ) : null}
                    <div className="d-flex pt-2 justify-content-end align-items-center">
                      <div
                        className="cursor-style"
                        onClick={() => handleCancelRemark()}
                      >
                        CANCEL
                      </div>
                      <div className="ms-2">
                        <Button
                          className="remark-button-bg"
                          type="submit"
                          variant="contained"
                        >
                          save
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              <div className="leave-remark-main-div">
                <div
                  className="leave-remark-text-style d-flex align-items-center ps-1 ms-3"
                  onClick={() => setShowRemark(!showRemark)}
                >
                  Leave remark...
                </div>
              </div>
            )}
            {remarks?.length > 0 &&
              remarks?.map((d, index) => {
                return (
                  <div
                    key={index}
                    className="add-border-between-remarks-goodsin"
                  >
                    <div className="p-3 padding-remark-adjust-class">
                      <div className="d-flex">
                        <img
                          style={{ borderRadius: "50%" }}
                          src={
                            d?.profileUrl ||
                            "https://img.freepik.com/free-icon/user_318-563642.jpg"
                          }
                          onError={imgError}
                          className="remark-avatar-style"
                        ></img>
                        <div className="ms-2">
                          <div className="remarkperson--name-shown-style">
                            {d?.firstName || ""} {d?.lastName || ""}{" "}
                          </div>
                          <div className="remarkperson--name-shown-style">
                            {moment(d?.timeStamp || "").format("LT")},
                            {moment(d?.timeStamp || "").format("DD MMM YYYY")}
                          </div>
                        </div>
                      </div>
                      <div className="pt-1 remark-comment-style">
                        {d.comments}
                      </div>
                    </div>
                  </div>
                );
              })}
            <div style={{ height: 100 }}></div>
          </div>
        </div >

        <Modal
          open={openApprovedModel}
          onClose={() => _openApprovedModel(!openApprovedModel)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <div>
              <div className="depot-form-header-style">
                <span className="allocate-mgnr-header-color me-2">
                  APPROVE GOODS IN RECORD
                </span>
                <span className="allocate-mgnr-subheader-color">
                  {goodsData?.referenceNumber || ""}
                </span>
              </div>
              <div style={{ paddingLeft: 100, paddingRight: 100 }}>
                <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                  <span className=" common-text-for-removeDepotManager add-approve-text-style mb-2">
                    You are approving{" "}
                  </span>
                  <span className=" common-text-for-removeDepotManager mb-2">
                    Goods In Record {goodsData?.referenceNumber || ""}{" "}
                  </span>
                  <span className="long-text-style-unlist-depot mb-1">
                    This record will be marked 'APPROVED' and you can edit this
                    record by revoking the approval.
                  </span>
                  {/* <span className="long-text-style-unlist-depot mb-1">
                    You can revoke approval within the next 48 hours, which will
                    enable editing again.
                  </span> */}
                  {/* <span className="long-text-style-unlist-depot mb-1">
                    After 48 hours from approval, the record will be locked
                    permanently.
                  </span> */}
                </div>

                <div className="d-flex flex-column" style={{ marginTop: 40 }}>
                  <span className="mb-3 confirm-msg-for-removeDepotManager">
                    Are you sure you want to proceed?
                  </span>
                  <div className="d-flex flex-row">
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style"
                      startIcon={
                        <img
                          src={IconLeftArrow}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                      onClick={handleApproveScreenGoBackClick}
                    >
                      No, Go Back
                    </Button>
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style ms-3"
                      style={{ color: "green", borderColor: "green" }}
                      onClick={handleApproveRecordButtonClick}
                      startIcon={
                        <img
                          src={require("../../assets/images/approved.png")}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                    >
                      YES, APPROVE RECORD
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <div className="depot-form-header-style">EDIT GOODS IN RECORD</div>
            <GoodsForm editData={goodsData} handleClose={handleClose} />
          </Box>
        </Modal>

        <Modal
          open={revokeApprovalModal}
          onClose={() => _revokeApprovalModal(!revokeApprovalModal)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <div>
              <div className="depot-form-header-style">
                <span className="allocate-mgnr-header-color me-2">
                  REVOKE APPROVAL GOODS IN RECORD{" "}
                </span>
                <span className="allocate-mgnr-subheader-color">
                  {goodsData?.referenceNumber || ""}
                </span>
              </div>
              <div style={{ paddingLeft: 100, paddingRight: 100 }}>
                <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                  <span className=" common-text-for-removeDepotManager add-revokeapproval-text-style">
                    You are revoking approval{" "}
                  </span>
                  <span className=" common-text-for-removeDepotManager mb-2">
                    for Goods In Record {goodsData?.referenceNumber || ""}{" "}
                  </span>
                  <span className="long-text-style-unlist-depot mb-1 mt-3">
                    This record will be marked 'REVIEW' and make editable.{" "}
                  </span>
                </div>

                <div className="d-flex flex-column" style={{ marginTop: 40 }}>
                  <span className="mb-3 confirm-msg-for-removeDepotManager">
                    Are you sure you want to proceed?
                  </span>
                  <div className="d-flex flex-row">
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style"
                      startIcon={
                        <img
                          src={IconLeftArrow}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                      onClick={() => _revokeApprovalModal(!revokeApprovalModal)}
                    >
                      No, Go Back
                    </Button>
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style ms-3"
                      style={{ color: "red", borderColor: "red" }}
                      onClick={handleRevokeApprovalButtonClick}
                      startIcon={
                        <img
                          src={IconRemove}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                    >
                      Yes, Revoke Approval
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={deleteRecordModal}
          onClose={() => _deleteRecordModal(!deleteRecordModal)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <div>
              <div className="depot-form-header-style">
                <span className="allocate-mgnr-header-color text-uppercase me-2">
                  DELETE GOODSIN RECORD
                </span>
                <span className="allocate-mgnr-subheader-color">
                  {goodsData?.referenceNumber}
                </span>
              </div>
              <div style={{ paddingLeft: 100, paddingRight: 100 }}>
                <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                  <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                    You are deleting{" "}
                  </span>
                  <span className="common-text-for-removeDeliveryOrder mb-2">
                    Goodsin Record which is in{" "}
                    <b
                      style={{
                        color:
                          goodsData?.statusValue == "Review" ? "red" : "green",
                      }}
                    >
                      {goodsData?.statusValue}
                    </b>{" "}
                    state
                    <strong>
                      {/* {getIndividualDispatchOrderDataMod?.orderNo || ""} */}
                    </strong>{" "}
                  </span>
                  <span className="long-text-style-unlist-depot mb-1">
                    This record will not appear on goodsin list.
                  </span>
                </div>
                <div className="d-flex flex-column mt-5">
                  <span className="mb-3 confirm-msg-for-removeDepotManager">
                    Are you sure you want to proceed?
                  </span>
                  <div className="d-flex flex-row">
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style"
                      startIcon={
                        <img
                          src={IconLeftArrow}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                      onClick={() => _deleteRecordModal(!deleteRecordModal)}
                    >
                      No, Go Back
                    </Button>
                    <Button
                      variant="outlined"
                      className="btn-bootstrap-submit-style ms-3"
                      style={{ color: "red", borderColor: "red" }}
                      onClick={handleDeleteRecordClick}
                      startIcon={
                        <img
                          src={IconCancel}
                          width={15}
                          height={15}
                          alt="new"
                        ></img>
                      }
                    >
                      YES, DELETE RECORD
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal open={showAllImages} onClose={handleClosemodal}>
          <Box sx={modalStyle1}>
            <UploadImage
              detailsView={true}
              toggle={handleClosemodal}
              selectedItemImagesArray={selectedItemImagesArray}
            />
          </Box>
        </Modal>
      </div >
    </>
  );
};
